module.exports = __webpack_public_path__ + "static/rfa-home@2x-300x266-4bf9ebe1124823936d89e378e61efdea.png";